export default function About() {
  return (
    <section id="salon-info" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            代表者からのメッセージ
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-2">
            頭皮、頭髪に悩む皆様に新しい未来を広げます。
            45年間、化粧品・ヘアケア開発に情熱を傾けてきた私たちが、
            お客様一人ひとりの美と健康のために心を込めてお手伝いいたします。
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 items-center mb-16 sm:mb-20">
          <div>
            <img
              src="https://static.readdy.ai/image/de97cb3378fc272fae271865aaf8f6bd/b18ba692f70297f059cbcbe625826a9f.jfif"
              alt="代表者"
              className="rounded-lg shadow-lg w-full h-64 sm:h-80 lg:h-96 object-cover object-top"
            />
          </div>
          <div className="px-2 sm:px-0">
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">
              最先端技術と伝統医学の融合
            </h3>
            <div className="space-y-3 sm:space-y-4 text-gray-600">
              <p className="flex items-start">
                <i className="ri-check-line text-amber-600 mr-3 mt-1 text-lg sm:text-xl flex-shrink-0"></i>
                <span className="text-sm sm:text-base">幹細胞上清液による先進的再生ケア</span>
              </p>
              <p className="flex items-start">
                <i className="ri-check-line text-amber-600 mr-3 mt-1 text-lg sm:text-xl flex-shrink-0"></i>
                <span className="text-sm sm:text-base">アーユルヴェーダの古代の知恵を活用</span>
              </p>
              <p className="flex items-start">
                <i className="ri-check-line text-amber-600 mr-3 mt-1 text-lg sm:text-xl flex-shrink-0"></i>
                <span className="text-sm sm:text-base">一人ひとりに合わせたホリスティックケア</span>
              </p>
              <p className="flex items-start">
                <i className="ri-check-line text-amber-600 mr-3 mt-1 text-lg sm:text-xl flex-shrink-0"></i>
                <span className="text-sm sm:text-base">完全個室でのプライベート空間</span>
              </p>
            </div>
          </div>
        </div>

        {/* ヘッドスパサービス詳細セクション */}
        <div id="head-spa-services" className="mb-16 sm:mb-20">
          <div className="text-center mb-12 sm:mb-16">
            <h3 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
              ヘッドスパサービス
            </h3>
            <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-2">
              45年の経験と最新技術を融合させた、究極のヘッドスパ体験をご提供いたします。
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-8 sm:mb-12">
            <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <i className="ri-add-line text-blue-600 text-xl sm:text-2xl"></i>
              </div>
              <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4 text-center">
                増毛コース
              </h4>
              <p className="text-gray-600 mb-3 sm:mb-4 text-center text-sm sm:text-base">
                薄毛や抜け毛にお悩みの方におすすめの専門コース
              </p>
              <ul className="space-y-2 text-xs sm:text-sm text-gray-600">
                <li className="flex items-center">
                  <i className="ri-check-line text-blue-600 mr-2 flex-shrink-0"></i>
                  <span>カウンセリング（初回のみ）</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-blue-600 mr-2 flex-shrink-0"></i>
                  <span>頭皮チェック</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-blue-600 mr-2 mt-1 flex-shrink-0"></i>
                  <div>
                    <span>増毛ヘッドスパ（30分～）</span>
                    <div className="text-xs text-gray-500 mt-1">※増毛（ましけ）</div>
                  </div>
                </li>
              </ul>
            </div>

            <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg border-2 border-amber-200 sm:col-span-2 lg:col-span-1">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <i className="ri-leaf-line text-amber-600 text-xl sm:text-2xl"></i>
              </div>
              <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4 text-center">
                3か月集中コース
              </h4>
              <p className="text-gray-600 mb-3 sm:mb-4 text-center text-sm sm:text-base">
                早く、確実に結果を求める集中的なヘッドスパコース
              </p>
              <ul className="space-y-2 text-xs sm:text-sm text-gray-600">
                <li className="flex items-center">
                  <i className="ri-check-line text-amber-600 mr-2 flex-shrink-0"></i>
                  <span>カウンセリング（初回のみ）</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-amber-600 mr-2 flex-shrink-0"></i>
                  <span>頭皮チェック</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-amber-600 mr-2 flex-shrink-0"></i>
                  <span>増毛ヘッドスパ（6回）</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-amber-600 mr-2 flex-shrink-0"></i>
                  <span>アフターケア指導</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg sm:col-span-2 lg:col-span-1">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <i className="ri-heart-pulse-line text-green-600 text-xl sm:text-2xl"></i>
              </div>
              <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4 text-center">
                メンテナンスコース
              </h4>
              <p className="text-gray-600 mb-3 sm:mb-4 text-center text-sm sm:text-base">
                定期的なケアで状態を維持するメンテナンスコース
              </p>
              <ul className="space-y-2 text-xs sm:text-sm text-gray-600">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-2 flex-shrink-0"></i>
                  <span>状態チェック・カウンセリング</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-2 flex-shrink-0"></i>
                  <span>メンテナンストリートメント</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-2 flex-shrink-0"></i>
                  <span>定期的なケアで状態を維持するメンテナンス</span>
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-600 mr-2 flex-shrink-0"></i>
                  <span>次回予約優待サービス</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="text-center">
            <button
              onClick={() =>
                document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })
              }
              className="bg-amber-600 hover:bg-amber-707 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold transition-colors cursor-pointer whitespace-nowrap inline-flex items-center"
            >
              <i className="ri-calendar-line mr-2"></i>
              ご予約・お問い合わせ
            </button>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg text-center">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
              <i className="ri-user-heart-line text-amber-600 text-xl sm:text-2xl"></i>
            </div>
            <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">
              個別カウンセリング
            </h4>
            <p className="text-gray-600 text-sm sm:text-base">
              お客様の状態やお悩みを丁寧にお聞きし、最適なケアプランをご提案いたします。
            </p>
          </div>

          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg text-center">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
              <i className="ri-hand-heart-line text-amber-600 text-xl sm:text-2xl"></i>
            </div>
            <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">専門技術</h4>
            <p className="text-gray-600 text-sm sm:text-base">
              長年の研究と実践で培われた独自の手技で、心地よいリラクゼーションをお届けします。
            </p>
          </div>

          <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg text-center sm:col-span-2 lg:col-span-1">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
              <i className="ri-time-line text-amber-600 text-xl sm:text-2xl"></i>
            </div>
            <h4 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">継続サポート</h4>
            <p className="text-gray-600 text-sm sm:text-base">
              定期的なケアを通じて、お客様の美と健康を長期的にサポートいたします。
            </p>
          </div>
        </div>

        {/* こだわりの成分セクション */}
        <div className="mt-16 sm:mt-20">
          <div className="text-center mb-12 sm:mb-16">
            <h3 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">
              こだわりの成分
            </h3>
            <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed px-2">
              最先端の再生医療技術と古代からの自然の恵みを融合させた、 こだわりの成分で究極のヘッドスパ体験をお届けします。
            </p>
          </div>

          <div className="grid lg:grid-cols-2 gap-8 sm:gap-12 mb-12 sm:mb-16">
            {/* 幹細胞培養上清液 */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/b1a4011ebb8a69a5a26357e9f7374219.jpg"
                alt="幹細胞培養上清液"
                className="w-full h-40 sm:h-48 object-cover object-top"
              />
              <div className="p-6 sm:p-8">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-blue-100 rounded-full flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className="ri-microscope-line text-blue-600 text-lg sm:text-xl"></i>
                  </div>
                  <h4 className="text-xl sm:text-2xl font-bold text-gray-900">
                    幹細胞培養上清液
                  </h4>
                </div>
                <p className="text-gray-600 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
                  最先端の再生医療技術から生まれた幹細胞培養上清液には、細胞の再生を促進する成長因子やサイトカインが豊富に含まれています。頭皮環境を整え、健やかな髪の成長をサポートします。
                </p>
                <div className="space-y-2 sm:space-y-3">
                  <div className="flex items-center">
                    <i className="ri-arrow-right-s-line text-blue-600 mr-2 flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm sm:text-base">細胞再生促進効果</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-arrow-right-s-line text-blue-600 mr-2 flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm sm:text-base">頭皮環境の改善</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-arrow-right-s-line text-blue-600 mr-2 flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm sm:text-base">血行促進作用</span>
                  </div>
                </div>
              </div>
            </div>

            {/* アーユルヴェーダハーブ */}
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Beautiful%20collection%20of%20traditional%20Ayurvedic%20medicinal%20herbs%20and%20spices%20arranged%20in%20elegant%20wooden%20bowls%20on%20clean%20white%20marble%20surface%2C%20including%20turmeric%20powder%2C%20dried%20brahmi%20leaves%2C%20bhringraj%20powder%2C%20amla%20powder%2C%20neem%20leaves%2C%20ashwagandha%20roots%2C%20gotu%20kola%2C%20tulsi%20leaves%2C%20fenugreek%20seeds%2C%20each%20herb%20in%20separate%20wooden%20bowls%20arranged%20in%20perfect%20symmetrical%20pattern%2C%20professional%20product%20photography%20with%20soft%20natural%20lighting%2C%20minimalist%20clean%20aesthetic%2C%20top%20view%20perspective&width=600&height=300&seq=ayurvedic-herbs-new&orientation=landscape"
                alt="アーユルヴェーダハーブ"
                className="w-full h-40 sm:h-48 object-cover object-top"
              />
              <div className="p-6 sm:p-8">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-green-100 rounded-full flex items-center justify-center mr-3 sm:mr-4 flex-shrink-0">
                    <i className="ri-leaf-line text-green-600 text-lg sm:text-xl"></i>
                  </div>
                  <h4 className="text-xl sm:text-2xl font-bold text-gray-900">アーユルヴェーダハーブ</h4>
                </div>
                <p className="text-gray-600 mb-4 sm:mb-6 leading-relaxed text-sm sm:text-base">
                  5000年の歴史を持つインドの伝統医学アーユルヴェーダで古くから使用されてきた貴重なハーブを厳選。自然の力で心身のバランスを整え、深いリラクゼーションと美しい髪へと導きます。
                </p>
                <div className="space-y-2 sm:space-y-3">
                  <div className="flex items-center">
                    <i className="ri-arrow-right-s-line text-green-600 mr-2 flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm sm:text-base">アシュワガンダ（細胞再生促進）</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-arrow-right-s-line text-green-600 mr-2 flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm sm:text-base">ゴツコラ（細胞修復活性化）</span>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-arrow-right-s-line text-green-600 mr-2 flex-shrink-0"></i>
                    <span className="text-gray-700 text-sm sm:text-base">トゥルシー（細胞代謝向上）</span>
                  </div>
                </div>
              </div>
            </div>

            {/* ... existing code ... */}
          </div>

          {/* 相乗効果の説明 */}
          <div className="bg-gradient-to-r from-blue-50 to-green-50 rounded-lg p-8 sm:p-12 text-center">
            <div className="w-16 h-16 sm:w-20 sm:h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6 shadow-lg">
              <i className="ri-magic-line text-amber-600 text-2xl sm:text-3xl"></i>
            </div>
            <h4 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">
              現代科学×古代の知恵
            </h4>
            <p className="text-lg sm:text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed px-2">
              最先端の幹細胞培養上清液と5000年の歴史を持つアーユルヴェーダハーブの組み合わせにより、 これまでにない相乗効果が実現。科学的根拠に基づいた現代の技術と、 長期長さが実証された自然の力が融合…
            </p>
          </div>

          {/* ... ... */}
        </div>

        {/* ... ... */}
      </div>
    </section>
  );
}
